import Led from "./Led";

export default Led;
